// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom = require("rescript-webapi/src/Webapi/Webapi__Dom.bs.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Webapi__Dom__HtmlElement = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__HtmlElement.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");

function stringify(_node) {
  return "domNode";
}

function whenContentEditable(f, node) {
  var htmlElement = Curry._1(Webapi__Dom__HtmlElement.ofNode, node);
  if (htmlElement !== undefined && Caml_option.valFromOption(htmlElement).isContentEditable) {
    return Curry._1(f, node);
  }
  
}

function isNodeOrItsAncestorDetached(node) {
  var _node = node;
  while(true) {
    var node$1 = _node;
    var match = Webapi__Dom__Node.nodeType(node$1);
    if (match === 8) {
      return false;
    }
    var parent = node$1.parentNode;
    if (parent == null) {
      return true;
    }
    _node = parent;
    continue ;
  };
}

function nodeType_encode(nodeType) {
  var tmp;
  switch (nodeType) {
    case /* Element */0 :
        tmp = 1;
        break;
    case /* Attribute */1 :
        tmp = 2;
        break;
    case /* Text */2 :
        tmp = 3;
        break;
    case /* CDATASection */3 :
        tmp = 4;
        break;
    case /* EntityReference */4 :
        tmp = 5;
        break;
    case /* Entity */5 :
        tmp = 6;
        break;
    case /* ProcessingInstruction */6 :
        tmp = 7;
        break;
    case /* Comment */7 :
        tmp = 8;
        break;
    case /* Document */8 :
        tmp = 9;
        break;
    case /* DocumentType */9 :
        tmp = 10;
        break;
    case /* DocumentFragment */10 :
        tmp = 11;
        break;
    case /* Notation */11 :
        tmp = 12;
        break;
    case /* Unknown */12 :
        tmp = -1;
        break;
    
  }
  return String(tmp);
}

function nodeType_decode(encoded) {
  var strInt = Js_json.decodeString(encoded);
  if (strInt !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: Webapi__Dom.decodeNodeType(Caml_format.caml_int_of_string(strInt))
          };
  } else {
    return Decco.error(undefined, "Couldn't decode json into DOM.Node.nodeType", encoded);
  }
}

function t__encode(v) {
  return Js_dict.fromArray([
              [
                "nodeName",
                Decco.stringToJson(v.nodeName)
              ],
              [
                "nodeValue",
                Decco.optionToJson(Decco.stringToJson, v.nodeValue)
              ],
              [
                "nodeType",
                nodeType_encode(v.nodeType)
              ]
            ]);
}

function t__decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var nodeName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nodeName"), null));
  if (nodeName.TAG === /* Ok */0) {
    var nodeValue = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nodeValue"), null));
    if (nodeValue.TAG === /* Ok */0) {
      var nodeType = nodeType_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nodeType"), null));
      if (nodeType.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  nodeName: nodeName._0,
                  nodeValue: nodeValue._0,
                  nodeType: nodeType._0
                }
              };
      }
      var e = nodeType._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".nodeType" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = nodeValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".nodeValue" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = nodeName._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".nodeName" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromDomNode(node) {
  return {
          nodeName: node.nodeName,
          nodeValue: Caml_option.nullable_to_opt(node.nodeValue),
          nodeType: Webapi__Dom__Node.nodeType(node)
        };
}

function stringify$1(node) {
  return JSON.stringify(t__encode(node));
}

var ForSerialization = {
  nodeType_encode: nodeType_encode,
  nodeType_decode: nodeType_decode,
  t__encode: t__encode,
  t__decode: t__decode,
  fromDomNode: fromDomNode,
  stringify: stringify$1
};

function contains(_nodeA, _nodeB) {
  while(true) {
    var nodeB = _nodeB;
    var nodeA = _nodeA;
    var exit = 0;
    var rootNodeA;
    try {
      rootNodeA = nodeA.getRootNode();
      exit = 1;
    }
    catch (raw_obj){
      var obj = Caml_js_exceptions.internalToOCamlException(raw_obj);
      if (obj.RE_EXN_ID === Js_exn.$$Error) {
        if (Caml_obj.caml_equal(obj._1.message, "Cannot read properties of undefined (reading 'getRootNode')")) {
          return false;
        }
        throw obj;
      }
      throw obj;
    }
    if (exit === 1) {
      var exit$1 = 0;
      var rootNodeB;
      try {
        rootNodeB = nodeB.getRootNode();
        exit$1 = 2;
      }
      catch (raw_obj$1){
        var obj$1 = Caml_js_exceptions.internalToOCamlException(raw_obj$1);
        if (obj$1.RE_EXN_ID === Js_exn.$$Error) {
          if (Caml_obj.caml_equal(obj$1._1.message, "Cannot read properties of undefined (reading 'getRootNode')")) {
            return false;
          }
          throw obj$1;
        }
        throw obj$1;
      }
      if (exit$1 === 2) {
        var match = Webapi__Dom__Node.nodeType(rootNodeA);
        var match$1 = Webapi__Dom__Node.nodeType(rootNodeB);
        var exit$2 = 0;
        var exit$3 = 0;
        if (match >= 11) {
          exit$3 = 4;
        } else {
          switch (match) {
            case /* Element */0 :
                return false;
            case /* Document */8 :
                if (match$1 >= 11) {
                  exit$2 = 3;
                } else {
                  switch (match$1) {
                    case /* Element */0 :
                        exit$3 = 4;
                        break;
                    case /* Document */8 :
                        return nodeA.contains(nodeB);
                    case /* Attribute */1 :
                    case /* Text */2 :
                    case /* CDATASection */3 :
                    case /* EntityReference */4 :
                    case /* Entity */5 :
                    case /* ProcessingInstruction */6 :
                    case /* Comment */7 :
                    case /* DocumentType */9 :
                        exit$2 = 3;
                        break;
                    case /* DocumentFragment */10 :
                        _nodeB = rootNodeB.host;
                        continue ;
                    
                  }
                }
                break;
            case /* Attribute */1 :
            case /* Text */2 :
            case /* CDATASection */3 :
            case /* EntityReference */4 :
            case /* Entity */5 :
            case /* ProcessingInstruction */6 :
            case /* Comment */7 :
            case /* DocumentType */9 :
                exit$3 = 4;
                break;
            case /* DocumentFragment */10 :
                if (match$1 >= 11) {
                  exit$2 = 3;
                } else {
                  switch (match$1) {
                    case /* Element */0 :
                        exit$3 = 4;
                        break;
                    case /* Document */8 :
                        _nodeA = rootNodeA.host;
                        continue ;
                    case /* Attribute */1 :
                    case /* Text */2 :
                    case /* CDATASection */3 :
                    case /* EntityReference */4 :
                    case /* Entity */5 :
                    case /* ProcessingInstruction */6 :
                    case /* Comment */7 :
                    case /* DocumentType */9 :
                        exit$2 = 3;
                        break;
                    case /* DocumentFragment */10 :
                        if (rootNodeA === rootNodeB) {
                          return nodeA.contains(nodeB);
                        }
                        _nodeB = rootNodeB.host;
                        continue ;
                    
                  }
                }
                break;
            
          }
        }
        if (exit$3 === 4) {
          if (match$1 === 0) {
            return false;
          }
          exit$2 = 3;
        }
        if (exit$2 === 3) {
          return Util$SmartcutsMacros.logAndRaiseJsError("Invalid nodeType combo (" + (JSON.stringify(nodeType_encode(match)) + (", " + (JSON.stringify(nodeType_encode(match$1)) + ")"))));
        }
        
      }
      
    }
    
  };
}

function hasParent(node) {
  var match = Webapi__Dom__Node.nodeType(node);
  return (
          match !== 10 ? Caml_option.nullable_to_opt(node.parentNode) : Caml_option.some(node.host)
        ) !== undefined;
}

function getDepthRelativeToBody(node) {
  var currNode = node;
  var depth = 0;
  while(hasParent(currNode) && !StringUtils$SmartcutsMacros.isAnyOf(currNode.nodeName, [
          "#document",
          "HTML",
          "html"
        ])) {
    depth = depth + 1 | 0;
    var match = Webapi__Dom__Node.nodeType(currNode);
    if (match !== 10) {
      var arg = currNode.parentNode;
      var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
      currNode = (function(arg$1){
        return function (param) {
          return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
        }
        }(arg$1))("Expected parent node");
    } else {
      currNode = currNode.host;
    }
  };
  return depth;
}

exports.stringify = stringify;
exports.whenContentEditable = whenContentEditable;
exports.isNodeOrItsAncestorDetached = isNodeOrItsAncestorDetached;
exports.ForSerialization = ForSerialization;
exports.contains = contains;
exports.hasParent = hasParent;
exports.getDepthRelativeToBody = getDepthRelativeToBody;
/* Webapi__Dom__Node Not a pure module */
